export default function Spinner() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-18 w-18 border-t-2 border-b-2 border-secondary"></div>
    </div>
  );
}
